import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import { useNavigate } from "react-router-dom";
import SimpleButton from "../../../Components/layouts/simple_button";
import StepRoutes from "../../../Routes/steps_routes";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { useSelector } from "react-redux";
import { roundOffCost } from "../../../Components/Functions/amt.fun";

const ViewEstimate = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false);
  const user = useSelector((store) => store?.login.user);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/estimate/getEstimateById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Invoice!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const MarkAsFinal = () => {
    // console.log("Updating Invoice ID:", id);
    performRequest("PATCH", `/estimate/updateEstimateStatus/${id}`)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Update Mark As Final");
          setRefresh(!refresh);
          navigate("/estimate");
        } else {
          Toast("error", "Error while getting Mark As Final !");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      });
  };

  const returnClassname = (status) => {
    if (status === "completed") {
      return "badge bg-success  text-white";
    } else if (status === "draft") {
      return "badge bg-danger  text-white";
    }
  };

  const DeleteInvoice = () => {
    // console.log("Updating Invoice ID:", id);
    performRequest("DELETE", `/estimate/deleteEstimate/${id}`)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Estimate deleted successfully");
          setRefresh(!refresh);
          navigate("/estimate");
        } else {
          Toast("error", "Error while getting Mark As Final !");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      });
  };

  const ConvertToInvoice = (values) => {
    let { invoiceNumber, manualInvoiceNumber, ...data } = values;
    values = {
      ...data,
      fromEstimate: invoiceNumber,
      generatedBy: user.Name,
      invoiceType: "invoice",
    };

    setLoading(true);
    performRequest("POST", "/invoice/createInvoice/", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Invoice created successfully!");
          navigate(`/client-invoice`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">Estimates Details</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">
                Estimate View :{" "}
                {data?.manualInvoiceNumber || data?.invoiceNumber}{" "}
              </h2>
            </div>
            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Client Project
                  </label>
                  <div className="w-100 col">
                    {(data?.clproject || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Estimate date</label>
                  <div className="w-100 col">
                    {(data.invoiceDate || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Business name</label>
                  <div className="w-100 col">
                    {(data?.businessName || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Contact person name
                  </label>
                  <div className="w-100 col">
                    {(data?.contactPersonName || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Phone number</label>
                  <div className="w-100 col">
                    {(data?.phoneNumber || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">GST number</label>
                  <div className="w-100 col">
                    {(data?.gstNumber || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Address</label>
                  <div className="w-100 col">
                    {(data?.address || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Country of supply
                  </label>
                  <div className="w-100 col">
                    {(data?.countryOfSupply || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Place of supply
                  </label>
                  <div className="w-100 col">
                    {(data?.billingAddress?.state || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && data?.billingAddress?.state !== "Maharashtra" && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Total IGST</label>
                  <div className="w-100 col">{data?.totalGst || "N/A"}</div>
                </div>
              )}
              {data && data?.billingAddress?.state == "Maharashtra" && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Total CGST</label>
                  <div className="w-100 col">
                    {data?.totalGst ? roundOffCost(+data?.totalGst / 2) : "N/A"}
                  </div>
                </div>
              )}
              {data && data?.billingAddress?.state == "Maharashtra" && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Total SGST</label>
                  <div className="w-100 col">
                    {data?.totalGst ? roundOffCost(data?.totalGst / 2) : "N/A"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Total amount (inc) GST
                  </label>
                  <div className="w-100 col">
                    {data?.totalAmountIncGst
                      ? roundOffCost(+data?.totalAmountIncGst)
                      : "N/A"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Notes</label>
                  <div className="w-100 col">
                    {(data?.notes || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Status</label>
                  <div className="w-100 col">
                    <span className={returnClassname(data?.status)}>
                      {" "}
                      {(data?.status || "N/A").toUpperCase()}
                    </span>
                  </div>
                </div>
              )}
              <hr />
              <h2>Line Items</h2>
              <hr />
              {data &&
                data.lineItems?.map((lineItem, index) => {
                  return (
                    <div>
                      <h2>{++index}.</h2>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Particulars
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.particulars || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Item unit
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.itemUnit || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Item quantity
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.itemQuantity || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Item price:
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.itemPrice || "N/A").toUpperCase()}
                        </div>
                      </div>
                      {data &&
                        data?.billingAddress?.state !== "Maharashtra" && (
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3">
                              IGST rate (%)
                            </label>
                            <div className="w-100 col">
                              {lineItem?.gstRate || "N/A"}
                            </div>
                          </div>
                        )}
                      {data &&
                        data?.billingAddress?.state === "Maharashtra" && (
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3">
                              CGST rate (%)
                            </label>
                            <div className="w-100 col">
                              {lineItem?.gstRate
                                ? +lineItem?.gstRate / 2
                                : "N/A"}
                            </div>
                          </div>
                        )}
                      {data &&
                        data?.billingAddress?.state === "Maharashtra" && (
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3">
                              SGST rate (%)
                            </label>
                            <div className="w-100 col">
                              {lineItem?.gstRate
                                ? +lineItem?.gstRate / 2
                                : "N/A"}
                            </div>
                          </div>
                        )}
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Discount (%)
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.discount || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">HSN</label>
                        <div className="w-100 col">
                          {lineItem?.HSN || "N/A"}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Amount (excl) gst
                        </label>
                        <div className="w-100 col">
                          {lineItem?.totalWithoutGst || "N/A"}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Amount (incl) gst
                        </label>
                        <div className="w-100 col">
                          {lineItem?.totalWithGst || "N/A"}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">Notes</label>
                        <div className="w-100 col">
                          {(lineItem?.notes || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <hr />
                    </div>
                  );
                })}
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <button
                  className="btn mx-1 mt-2 btn-green"
                  disabled={data?.status === "completed"}
                  onClick={MarkAsFinal}
                >
                  MARK AS FINAL
                </button>
                {(user.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                  user.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                  <button
                    className="btn mx-1 mt-2 btn-red"
                    onClick={DeleteInvoice}
                  >
                    DELETE ESTIMATE
                  </button>
                )}

                <button
                  className="btn mx-1 mt-2 btn-primary"
                  onClick={() => ConvertToInvoice(data)}
                >
                  CONVERT TO INVOICE
                </button>

                <SimpleButton
                  buttonText={"generate pdf"}
                  href={`/estimate/preview/${id}`}
                />
                <SimpleButton
                  buttonText="Edit ESTIMATE"
                  href={`/estimate/edit/${id}`}
                />

                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewEstimate;
